<crm-task-form
  *ngIf="(loading$ | async) === false"
  [isModal]="true"
  [task]="$any(task)"
  [operation]="operation"
  [canDelete]="(form$ | async)?.isEdit"
  [activeStep]="activeStep"
  [permissions]="taskEditPermissions"
  [organizations]="organizations"
  [filials]="filials"
  [units]="units"
  [priorities]="priorities"
  [directions]="directions"
  [nds]="nds"
  [banks]="banks"
  [statuses]="statuses"
  [kindLoading]="kindLoading"
  [schemes]="schemes"
  [currencies]="currencies"
  [bankDetails]="bankDetails"
  [contragentBankDetails]="contragentBankDetails"
  [defaultAgent]="defaultAgent"
  (changeOrganization)="changeOrganization($event)"
  (reloadOrganizationBankDetails)="reloadOrganizationBankDetailsIfNeeded()"
  (changeResponsible)="changeResponsibleUser($event)"
  (changeContragent)="onContragentChange($event)"
  (bankSearch)="searchBank($event)"
  (save)="saveTask($event)"
  (delete)="deleteTask($event)">
</crm-task-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
